
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 18.208V8h12v10.208c0 .473-.203.89-.61 1.25a2.054 2.054 0 01-1.406.542H8.016c-.532 0-1-.18-1.407-.542-.406-.36-.609-.777-.609-1.25zM19 5.5V7H5V5.5h3.5L9.681 4h4.638L15.5 5.5H19z","fill-rule":"evenodd"}})])
          )
        }
      }
    